<template>
    <div style="display: flex; flex-direction: column; border-radius: 8px; height: 140px"
         :style="{'background-color': design.backgroundColor, 'color': design.textColor}">
        <div style="display: flex; height: 110px">
            <div class="flex-grow-1"
                 style="display: flex;
                 align-items: flex-start;
                 justify-content: flex-start;
                  font-size: 22px;
                  line-height: 26px;
                  padding: 24px 16px;">
                {{ room.name }}
            </div>
            <div style="font-size: 48px; display: flex; align-items: center; justify-content: center; padding: 16px">
                <i :class="design.icon"></i>
            </div>
        </div>
        <div style="background-color: rgba(0, 0, 0, .1);
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    padding: 0 12px;
                    justify-content: space-between;"
                    class="flex-grow-1"
                    :style="{ justifyContent: getJustifyContent(room.status) }">
            <div>{{ room.status }}</div>
            <div style="display: flex"v-if="room.status ==='OCUPADO' || room.status ==='DISPONIBLE' || room.status ==='LIMPIEZA'">
                <x-button-icon @click="$emit('action')"
                               icon="fal fa-hand-point-right"></x-button-icon>
                <template v-if="room.status ==='OCUPADO'">
                    <x-button-icon @click="$emit('click-add-item')"
                                   icon="fal fa-box"
                                   tooltip-content="Agregar productos"></x-button-icon>
                    <x-button-icon @click="$emit('click-extend-time-room')"
                                   type="warning"
                                   icon="fal fa-clock"
                                   tooltip-content="Extender Tiempo"></x-button-icon>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import XButtonIcon from "../Form/XButtonIcon.vue";

export default {
    name: 'XHotelRoom',
    components: {XButtonIcon},
    props: {
        room: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tip: {},
        }
    },
    computed: {
        design() {
            if (this.room.status === 'DISPONIBLE') {
                return {
                    backgroundColor: '#28a745',
                    textColor: '#fff',
                    icon: 'fal fa-bed-alt',
                }
            }
            if (this.room.status === 'RESERVADO') {
                return {
                    backgroundColor: '#17a2b8',
                    textColor: '#fff',
                    icon: 'fal fa-calendar-alt',
                }
            }
            if (this.room.status === 'MANTENIMIENTO') {
                return {
                    backgroundColor: '#ffc107',
                    textColor: '#000',
                    icon: 'fal fa-vacuum',
                }
            }
            if (this.room.status === 'LIMPIEZA') {
                return {
                    backgroundColor: '#ffc107',
                    textColor: '#000',
                    icon: 'fal fa-vacuum',
                }
            }
            if (this.room.status === 'OCUPADO') {
                return {
                    backgroundColor: '#dc3545',
                    textColor: '#fff',
                    icon: 'fal fa-bed-alt',
                }
            }
        },
    },
    methods: {
        getJustifyContent(status) {
            return (status === 'OCUPADO' || status === 'DISPONIBLE' || status === 'LIMPIEZA')? 'space-between' : 'center'
        },
    }
}
</script>
